import { ALGOLIA_PRODUCT_TYPES } from "@/utils/algoliaCatalog";
import { useCatalogSummary } from "hooks/useCatalogSummary";

const MIN_LISTINGS_FOR_RECOMMENDATIONS = 10;

/** The record types `GET /listings` counted: treatments, packages and retail — not memberships or gift cards. */
const RECOMMENDABLE_PRODUCT_TYPES = [
  ALGOLIA_PRODUCT_TYPES.treatment,
  ALGOLIA_PRODUCT_TYPES.package,
  ALGOLIA_PRODUCT_TYPES.retailProduct,
];

export const recommendableListingCount = (productTypeCounts: Record<string, number>): number =>
  RECOMMENDABLE_PRODUCT_TYPES.reduce((sum, type) => sum + (productTypeCounts[type] ?? 0), 0);

export const useRecommendationsEligibility = () => {
  const { data: catalog } = useCatalogSummary();

  return {
    hasEnoughListings:
      recommendableListingCount(catalog?.productTypeCounts ?? {}) >=
      MIN_LISTINGS_FOR_RECOMMENDATIONS,
  };
};
